import type { ModelOrderResponse } from '@layup/api-sdk';

export const PAYMENT_PLAN_MERCHANTS = (import.meta.env.VITE_PAYMENT_PLAN_MERCHANTS ?? '').split(',').filter(Boolean);

export const isPaymentPlanMerchant = (order: ModelOrderResponse) =>
  PAYMENT_PLAN_MERCHANTS.includes(order.merchantId ?? '');
